<template>
  <div>
    <template v-if="inline">
      <form-item label-width="80" labelAlign="left" label="选择模型分类">
        <el-select v-model="selectApp" value-key="id" clearable size="small" @change="handleAppChange">
          <el-option v-for="item in appList" :key="item.id" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </form-item>
      <form-item label-width="80" labelAlign="left" label="选择数据模型">
        <el-select filterable v-model="selectAction" value-key="id" clearable size="small" @change="handleActionChange">
          <el-option v-for="item in actionList" :key="item.id" :label="item.name"
                     :value="item.sourceCode || item.code"></el-option>
        </el-select>
        <el-link
            class="ml-4 fs-20 pointer"
            :icon="Refresh"
            @click="handleActionChange(model?.code)"
            :underline="false"
            type="primary"
        ></el-link>
      </form-item>
    </template>
    <template v-else>
      <el-select v-show="!props.isOnlyDataSet" v-model="selectAppType" value-key="id" clearable size="small"
                 @change="handleAppChangeType"
                 placeholder="选择模型分类" class="mt-10">
        <el-option v-for="item in appTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <el-select v-model="selectApp" value-key="id" clearable size="small" @change="handleAppChange"
                 placeholder="选择主题/业务分类" class="mt-10">
        <el-option v-for="item in appList" :key="item.id" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <!-- <div class="font-weight mt-10 mb-10">选择数据模型</div> -->
      <div class="flex mt-10">
        <el-select filterable v-model="selectAction" value-key="id" clearable size="small" @change="handleActionChange"
                   placeholder="选择数据模型">
          <el-option v-for="item in actionList" :key="item.id" :label="item.name"
                     :value="item.sourceCode || item.code"></el-option>
        </el-select>
        <el-link
            class="ml-4 fs-20 pointer"
            :icon="Refresh"
            @click="handleActionChange(model?.code, 'Refresh')"
            :underline="false"
            type="primary"
        ></el-link>
      </div>
    </template>
  </div>
</template>

<script setup>
import {ref, reactive, computed, watch, inject, unref} from "vue";
import {useCommonMix} from "@/option/common/commonmix";
import {bizPath, dataCenterDao} from "@/option/common/dao";
import {ACTION_TYPE, DATA_SOURCE_TYPE, ServiceTypeList} from "@/option/common/dict.js";
import {Delete, Refresh} from "@element-plus/icons-vue";
import {request} from "@/option/common/dao.js";

let props = defineProps({
  showSelect: {
    default: true,
  },
  isOnlyDataSet: {
    default: false
  },
  filterSelected: {
    default: true,
  },
  modelValue: {},
  // 图标配置是公用的一个组件 所以需要监听选中组件改变，然后重置选择的接口
  option: {},
  inline: {
    type: Boolean,
  },
  // 指标卡特殊处理
  isIndexCard: {
    type: Boolean,
  },
});
const emit = defineEmits(["select", "close"]);
const {confirm, success, warning, error} = useCommonMix();
defineExpose({
  initSet
});
let getApp = inject('getApp', null)
let app = getApp ? getApp() : inject("app", {})
let depends = app.deptList
let appList = ref([]);
const appTypeList = ref([])
// 选择功能点的参数
let selectApp = ref(null);
let initType = props.isOnlyDataSet ? 'folder' : 'market'
const selectAppType = ref(initType); // add 数据分析增加模型分类
let selectAction = ref(null);
let metricsParams = ref([]);
let dimensionsParams = ref([]);
let queryParams = ref([]);
let actionList = ref([]);
let requestParams = ref([]);
let responseParams = ref([]);

function handleClose() {
  emit("close");
}

// 服务类型
const serviceType_list = ServiceTypeList
getTypeList()

function getTypeList() {
  request({
    url: '/system-basic/sysDictItem/getByDictCode',
    data: {"dictCode": "data_model_type"},
  }).then((res) => {
    appTypeList.value = res
  })
}

if (props.option) {
  // 切换图表组件重新清空数据
  watch(
      () => props.option.ref,
      () => {
        let cache = props.modelValue.dataCenter
        if (cache) {
          selectAppType.value = props.isOnlyDataSet ? 'folder' : cache.modelCategorize

          getBizTypes()
          selectApp.value = props.isOnlyDataSet ? 'folder' : cache.modelType;
          handleAppChange(cache.modelType).then(() => {
            selectAction.value = cache.modelId;
            // 只刷新  不清空之前的
            handleActionChange(cache.modelId, 'Refresh')
          })
        } else {
          selectAppType.value = initType
          selectApp.value = null;
          selectAction.value = null;
          actionList.value = [];
        }
      },
  );
}

function getBizTypes() {
  const type = selectAppType.value === 'biz_unit_app' ? 'biz_unit' : selectAppType.value
  dataCenterDao.getBizTypes({type}).then((el) => {
    // dataCenterDao.getBizTypes({ type: props.isIndexCard ? "market" : "biz_unit" }).then((el) => {
    appList.value = el;
  });
}

selectAppType.value = props.modelValue.dataCenter?.modelCategorize ?? initType;

getBizTypes();

function handleAppChangeType(v) {
  if (!v) return;
  selectApp.value = null
  selectAction.value = null;
  getBizTypes();
}

function handleAppChange(v) {
  if (!v) return;
  let item = appList.value.find(el => el.code === v)

  return dataCenterDao
      .getModelTypes({
        bizType: v,
        modelVersionNum: item?.sourceVersionNum || item?.versionNum,
        serviceType: serviceType_list[selectAppType.value],
        // serviceType: props.isIndexCard ? DATA_SOURCE_TYPE.REPORT : DATA_SOURCE_TYPE.DATA_CENTER,
      })
      .then((res) => {
        selectAction.value = null;
        metricsParams.value = [];
        dimensionsParams.value = [];
        queryParams.value = [];
        actionList.value = res;
      });
}

let model;

// type 是否刷新
function handleActionChange(v, type = '') {
  if (!v) {
    if (props.modelValue?.dataCenter?.modelId) {
      v = props.modelValue.dataCenter.modelId || selectApp.value;
    } else {
      return;
    }
  }
  model = actionList.value.find((el) => el.code === v || el.sourceCode === v);
  //modelSource =  market: 'data_model'; biz_unit_app: 'biz_data_model'; biz_unit:  model?.modelSource
  //serviceType =  market: DATA_SOURCE_TYPE.DATA_CENTER; biz_unit_app: DATA_SOURCE_TYPE.REPORT ; biz_unit:  'biz_data_model'
  // 模型 类型
  const modelSource_list = {
    market: 'data_model',
    biz_unit_app: 'biz_data_model',
    biz_unit: model?.modelSource
  }

  dataCenterDao
      .getParams({
        modelCode: v,
        modelVersionNum: model?.sourceVersionNum || model?.versionNum,
        serviceType: serviceType_list[selectAppType.value], // selectAppType.value === 'market' ? DATA_SOURCE_TYPE.REPORT : DATA_SOURCE_TYPE.DATA_CENTER, // 2023年12月21日，大老师同步，数据模型传dataReport，业务模型传dataCount
        // serviceType: props.isIndexCard ? DATA_SOURCE_TYPE.REPORT : DATA_SOURCE_TYPE.DATA_CENTER,
        modelSource: modelSource_list[selectAppType.value],

      })
      .then((res) => {
        metricsParams.value = res.kpiList ?? [];
        dimensionsParams.value = res.dimList ?? [];
        queryParams.value = res.filterList ?? [];
        requestParams.value = res.dtoRequest?.openApiDtoFieldsDtoList ?? [];
        responseParams.value = res.dtoResponse?.openApiDtoFieldsDtoList ?? [];
        handleSelectAction(model, type);
      });
}

initSet()

function initSet() {
  if (props.modelValue.dataCenter) {
    selectApp.value = props.modelValue.dataCenter.modelType;
    // selectAppType.value = props.modelValue.dataCenter.modelCategorize;
    handleAppChange(selectApp.value).then(() => {
      selectAction.value = props.modelValue.dataCenter.modelId;
      // 如果没有拿到模型配置 刷新配置
      if (!props.modelValue?.rMetrics?.length) {
        handleActionChange(props.modelValue.dataCenter.modelId, 'Refresh')
      }
    });
  }
}

function handleSelectAction(action, type = '') {
  // 数据中心标识Nchartset
  props.modelValue.dataSourceType = DATA_SOURCE_TYPE.DATA_CENTER;
  props.modelValue.dataCenter = {
    modelCategorize: selectAppType.value,
    modelType: selectApp.value,
    modelId: selectAction.value,
    modelSource: selectAppType.value,// action?.modelSource,
    name: action?.name,
    // 和杨亮沟通 暂时先删除这个字段 仅仅为了适配双碳地图
    // appList: appList?.value,
    versionNum: action?.sourceVersionNum || action?.versionNum
  };
  // 	图表等组件配置
  emit(
      "select",
      props.modelValue.dataCenter,
      convertData(metricsParams.value),
      convertData(dimensionsParams.value),
      convertData(queryParams.value),
      type !== 'Refresh'
  );
}

function convertData(params) {
  return params.map((p) => {
    return {
      ...p,
    };
  });
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.dialog-wrap {
  height: 50vh;
  overflow: auto;
  padding-right: $gap;
}

.param-title {
  margin: $gap 0;
  font-size: 14px;
  font-weight: 700;
}

.btn-wrap {
  margin: $gap;
  text-align: center;
}
</style>
